// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3837":"9925f088957dd35e","6816":"9bc7bae2d3f03059"}[chunkId] + ".js";
};